import { ArticleHeading5, ArticleParagraph2, Image } from '@cian/ui-kit';
import * as React from 'react';
import { IProjectItemProps } from '../../../types';
import * as styles from './ProjectItem.css';

export const ProjectItem: React.FC<IProjectItemProps> = ({ url, features, startPrice, materials, image, onClick }) => {
  return (
    <a href={url} className={styles['link']} onClick={onClick}>
      <div className={styles['item']}>
        <div className={styles['image-container']}>
          <Image src={image?.thumbnail ?? ''} objectFit="cover" />
        </div>
        <div className={styles['info']}>
          <ArticleHeading5>{startPrice}</ArticleHeading5>
          <ArticleParagraph2>{features}</ArticleParagraph2>
          <ArticleParagraph2>{materials}</ArticleParagraph2>
        </div>
      </div>
    </a>
  );
};
